import "./index.less"
const LinkButton = (props)=>{
    return <button className="link-button" {...props}></button>
}

export default LinkButton